/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreditAlertSettings} from '../models/CreditAlertSettings';
import type {Error} from '../models/Error';

export interface GetCreditAlertSettings$Request {
    accountId: number;
}

export interface GetCreditAlertSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCreditAlertSettingsRequest = createAction<PayloadData<void, GetCreditAlertSettings$Request>>('ALERT_CONTROLLER__GET_CREDIT_ALERT_SETTINGS__REQUEST');
export const getCreditAlertSettingsSuccess = createAction<PayloadData<CreditAlertSettings, GetCreditAlertSettings$Request>>('ALERT_CONTROLLER__GET_CREDIT_ALERT_SETTINGS__SUCCESS');
export const getCreditAlertSettingsFailure = createAction<PayloadData<Error, GetCreditAlertSettings$Request, true>>('ALERT_CONTROLLER__GET_CREDIT_ALERT_SETTINGS__FAILURE');

export const getCreditAlertSettingsActions = [
    getCreditAlertSettingsRequest,
    getCreditAlertSettingsSuccess,
    getCreditAlertSettingsFailure
] as const;

/**
 * Credit alert settings
 * @param {number} meta.accountId Id of account
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCreditAlertSettings = (meta: GetCreditAlertSettings$Request, config?: GetCreditAlertSettings$Config) => {
    return {
        CALL_API: {
            types: getCreditAlertSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/api-v2/${meta.accountId}/alerts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveCreditAlertSettings$Request {
    accountId: number;
    creditAlertSettings?: CreditAlertSettings;
}

export interface SaveCreditAlertSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveCreditAlertSettingsRequest = createAction<PayloadData<void, SaveCreditAlertSettings$Request>>('ALERT_CONTROLLER__SAVE_CREDIT_ALERT_SETTINGS__REQUEST');
export const saveCreditAlertSettingsSuccess = createAction<PayloadData<void, SaveCreditAlertSettings$Request>>('ALERT_CONTROLLER__SAVE_CREDIT_ALERT_SETTINGS__SUCCESS');
export const saveCreditAlertSettingsFailure = createAction<PayloadData<Error, SaveCreditAlertSettings$Request, true>>('ALERT_CONTROLLER__SAVE_CREDIT_ALERT_SETTINGS__FAILURE');

export const saveCreditAlertSettingsActions = [
    saveCreditAlertSettingsRequest,
    saveCreditAlertSettingsSuccess,
    saveCreditAlertSettingsFailure
] as const;

/**
 * Save credit alert settings
 * @param {number} meta.accountId Id of account
 * @param {CreditAlertSettings} [meta.creditAlertSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveCreditAlertSettings = (meta: SaveCreditAlertSettings$Request, config?: SaveCreditAlertSettings$Config) => {
    return {
        CALL_API: {
            types: saveCreditAlertSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/api-v2/${meta.accountId}/alerts`,
            TRANSPORT_REQUEST_BODY: meta.creditAlertSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

